import React, { useState, useEffect, useContext } from 'react';
import './Event.css';
import { format, parseISO } from 'date-fns';
import { CardNextEventContext } from '../../contexts/CardNextEventContext';
import logComponent from '../../common/logComponent';

export default function EventContent() {
  const cardNextEventContext = useContext(CardNextEventContext);
  const [contentData, setContentData] = useState(null);

  if (logComponent('EventContent')) { console.debug('EventContent rendered'); }

  useEffect(() => {
    if (logComponent('EventContent')) { console.debug('EventContent useEffect [cardNextEventContext.nextEvent]'); }
    setContentData({ ...cardNextEventContext.nextEvent });
  }, [cardNextEventContext.nextEvent]);


  const getSelectedDateTimeFormatted = (date) => {
    if (logComponent('EventContent')) {console.debug('EventContent getSelectedDateWeekday'); }
    return date ? format(parseISO(date), 'h:mm aaa') : null;

  }

  const getSelectedDateFormatted = (date) => {
    if (logComponent('EventContent')) {console.debug('EventContent getSelectedDateFormatted'); }
    return date ? format(parseISO(date), 'MMMM d, yyyy') : null;

  }

  return (contentData &&
    (contentData.socialEventId === 0 ?
      <p className="Event__empty-message">No future events found.</p> :
      <React.Fragment>
        <p className="Event__title">{contentData.name}</p>
        <p className="Event__description">{contentData.description}</p>
        <dl className="Event__details">
          <dt>Date:</dt>
          <dd>{getSelectedDateFormatted(contentData.localStartOn)}</dd>
          <dt>Time:</dt>
          <dd>{getSelectedDateTimeFormatted(contentData.localStartOn)}</dd>
          <dt>Location:</dt>
          <dd>{contentData.location}</dd>
          <dt>Remaining spaces:</dt>
          <dd>{contentData.remainingSpaces}</dd>
        </dl>
      </React.Fragment>));
}
